const SixtyForty = {
    classNames: {
        preTitle: 'sixty-forty__content--preTitle',
        title: 'sixty-forty__content--mainTitle',
        content: 'sixty-forty__content--textCopy',
        button: 'sixty-forty__content--cta',
        image: 'sixty-forty__image',
        mobileImage: 'sixty-forty__mobile-image__src',
        disclaimer: 'sixty-forty__content--disclaimerCopy'
    }
};

export default SixtyForty;
